// Components
import Loading from '../Loading/Loading';

// Libs
import dropdown from "@df/js/components/dropdown";


const classNames = require('classnames');

import { useEffect, useState } from '@wordpress/element';

const Box = ({
    header,
    grid,
    children,
    backgroundColor = 'white',
    className,
    loading,
    textColor,
    vertical,
    collapsible,
    noPadding,
    style = undefined,
}) => {

    const [gridCols, setGridCols] = useState(1);
    const [open, setOpen] = useState(false);

    // Set grid cols
    useEffect(() => {
        if (children) {
            setGridCols(vertical ? 1 : children.length);
        }
    }, [children, vertical]);

    // Collapse box
    useEffect(() => {
        if (collapsible) {
            setOpen(collapsible.open);
        }
    }, [collapsible]);

    // Init Dropdown Lib for Switcher
    useEffect(() => {
        dropdown.init();
        const handleDropboxChanged = (event) => {
            const { name, value } = event.detail;
            if(header?.switcher?.name === name){
                header?.switcher?.callback(value)
            }
        };
        window.addEventListener("dropboxChanged", handleDropboxChanged);
        return () => {
            window.removeEventListener("dropboxChanged", handleDropboxChanged);
        };
    }, [])

    // Set box class
    const boxClass = classNames({
        box: true,
        [`bg-${backgroundColor}`]: backgroundColor,
        [`text-${textColor}`]: textColor,
        'box--with-title': header,
        [className]: className,
        'box--collapsible': collapsible,
        'box--collapsible--open': open,
        'border-0': collapsible,
    });

    // Set box header class
    const boxHeaderClass = classNames({
        box__header: true,
        [`bg-${header && header.color ? header.color : 'white'}`]: header && header.color,
        'box__header--with-color': header && header.color,
        [`text-${header && header.textColor ? header.textColor : 'navy-100'}`]: header && header.textColor,
    });

    // Set box content class
    const boxContentClass = classNames({
        box__content: true,
        'md:grid gap-6': grid,
        [`md:grid-cols-${gridCols}`]: grid,
        'flex flex-col': true,
        'box__content--multiple-children': children && children.length > 1,
        'box__content--vertical': vertical || collapsible,
        'box__content--no-padding': noPadding,
    });


    return <div className={boxClass} style={style}>
        {loading && <Loading overlay />}

        {header && <div
            className={boxHeaderClass}
            onClick={() => collapsible && setOpen(!open)}
        >
            <div className="box__header__info">
                {header.title &&
                    <div
                        className="box__header__info__title"
                        dangerouslySetInnerHTML={{ __html: header.title }}
                    />
                }
                {header.titleAlt &&
                    <div className="box__header__info__title">
                        {header.titleAlt}
                    </div>
                }
                {header.info && <div className="box__header__info__subtitle">{header.info}</div>}
            </div>

            {header.switcher && <div className="box__header__switcher">
                <select
                    data-module="dropdown"
                    name={header.switcher.name}
                    className="box__select"
                    >
                    {header.switcher.fields.map(item => {
                        return <option key={item.value} value={item.value} selected={item.default}>{item.label}</option>;
                    })}
                </select>
            </div>}

            {collapsible && <div className={`icon ${!open ? 'icon-expand-more' : 'icon-expand-less'}`} />}
        </div>
        }

        {
            (open || !collapsible) &&
            <div className={boxContentClass}>
                {children}
            </div>
        }

    </div>;
};

export default Box;
